// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._947684>svg{color:var(--primary)}._9ef6c3>svg{color:var(--green)}.fee734>svg{color:var(--alert)}._56ae95>svg,.a8b8c3>svg{color:var(--danger)}", ""]);
// Exports
exports.locals = {
	"thank": "_947684",
	"note": "_9ef6c3",
	"idea": "fee734",
	"concern": "_56ae95",
	"question": "a8b8c3"
};
module.exports = exports;
